import React, { useState } from "react";
import "./WeatherWave.css";

let clear = "assets/clear.png";
let cloud = "assets/cloud.png";
let dizzle = "assets/drizzle.png";
let rain = "assets/rain.png";
let snow = "assets/snow.png";
let mist = "assets/mist.png";
let tmeter = "assets/thermometer.png";
let tstorm = "assets/tstorm.png";

const WeatherWave = () => {
  const [img, setImg] = useState(tmeter);

  const searchData = async () => {
    try {
      let element = document.getElementsByClassName("input");
      let location = document.getElementsByClassName("weather-location")[0];
      let temp = document.getElementsByClassName("weather-temp")[0];
      let humidity = document.getElementsByClassName("humidity-percentage")[0];
      let wind = document.getElementsByClassName("wind-rate")[0];
      let api_key = "6c463f9cab1bad4dec3bfe69cbd68dfb";
      let loc = element[0].value;
      if (loc.trim() === "") {
        return 0;
      }

      let url = `https://api.openweathermap.org/data/2.5/weather?q=${loc}&units=Metric&appid=${api_key}`;
      const res = await fetch(url);
      const d = await res.json();

      temp.innerHTML = Math.floor(d.main.temp) + " °C";
      location.innerHTML = d.name;
      humidity.innerHTML = Math.floor(d.main.humidity) + " %";
      wind.innerHTML = Math.floor(d.wind.speed) + " km/h";
      let code = d.weather[0].code;
      console.log(code);

      if (d.weather[0].icon === "01d" || d.weather[0].icon === "01n") {
        setImg(clear);
      } else if (d.weather[0].icon === "02d" || d.weather[0].icon === "02n") {
        setImg(cloud);
      } else if (d.weather[0].icon === "03d" || d.weather[0].icon === "03n") {
        setImg(dizzle);
      } else if (d.weather[0].icon === "04d" || d.weather[0].icon === "04n") {
        setImg(dizzle);
      } else if (d.weather[0].icon === "09d" || d.weather[0].icon === "09n") {
        setImg(rain);
      } else if (d.weather[0].icon === "10d" || d.weather[0].icon === "10n") {
        setImg(snow);
      } else if (d.weather[0].icon === "11d" || d.weather[0].icon === "11n") {
        setImg(tstorm);
      } else if (d.weather[0].icon === "13d" || d.weather[0].icon === "13n") {
        setImg(snow);
      } else if (d.weather[0].icon === "50d" || d.weather[0].icon === "50n") {
        setImg(mist);
      } else {
        setImg(tmeter);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="container">
      <div className="weather-box">
        <div className="search-bar">
          <input type="text" placeholder="search" className="input" />
          <img src="assets/search.png" alt="" onClick={searchData} />
        </div>
        <div className="w-status">
          <img src={img} className="weather-status" alt="" />
        </div>
        <div className="weather-temp">-°C</div>
        <div className="weather-location">place</div>

        <div className="weather-info">
          <div className="humidity-info">
            <img src="assets/humidity.png" alt="" />
            <div>
              <h2 className="humidity-percentage">- %</h2>
              <p>Humidity</p>
            </div>
          </div>
          <div className="wind-info">
            <img src="assets/wind.png" alt="" />
            <div>
              <h2 className="wind-rate">- km/h</h2>
              <p>Wind Rate</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeatherWave;
